export const questionnaire_B2 = {
    name: '問卷 B-2',
    subtitle: '以下題目詢問你在剛才的線上閱讀任務中採用的閱讀方法。<br/>請只根據剛才完成任務時的實際做法回答，題目沒有對錯。',
    sections: [
        [
            {
                id: 'A',
                title: 'A　材料之間的聯繫',
                hint: '請評定你在剛才的閱讀任務中，在多大程度上有以下做法。',
                options: [
                    '完全沒有',
                    '程度較低',
                    '中等程度',
                    '程度較高',
                    '程度非常高'
                ],
                questions: [
                    { question: '我嘗試透過比較不同材料的內容，理解所閱讀的主題。' },
                    { question: '我嘗試留意不同材料的說法有哪些不一致之處。' },
                    { question: '我嘗試弄清不同材料的內容之間有甚麼關係。' },
                    { question: '我嘗試找出在多份材料中重複出現的觀點。' },
                    { question: '我思考不同材料對同一個問題是否有互相矛盾的觀點。' }
                ]
            }
        ],
        [
            {
                id: 'B',
                title: 'B　材料之間的聯繫',
                hint: '請評定你在剛才的閱讀任務中，在多大程度上有以下做法。',
                options: [
                    '完全沒有',
                    '程度較低',
                    '中等程度',
                    '程度較高',
                    '程度非常高'
                ],
                questions: [
                    { question: '我思考不同材料對同一個問題的不同解釋是否可以同時成立。' },
                    { question: '我嘗試比較不同材料對同一個問題成因的解釋。' },
                    { question: '我嘗試概括多份材料的內容。' },
                    { question: '我嘗試思考材料中提到的情況與應對措施之間有甚麼關係。' },
                    { question: '我嘗試全面了解材料所討論的問題可能帶來哪些後果。' }
                ]
            }
        ],
        [
            {
                id: 'C',
                title: 'C　資訊的收集與記憶',
                hint: '請評定你在剛才的閱讀任務中，在多大程度上有以下做法。',
                options: [
                    '完全沒有',
                    '程度較低',
                    '中等程度',
                    '程度較高',
                    '程度非常高'
                ],
                questions: [
                    { question: '我集中精神，盡可能多記住各份材料中的事實資訊。' },
                    { question: '我著重從各份材料中獲取盡可能多的資訊。' },
                    { question: '閱讀不同材料時，我盡可能多蒐集事實資訊。' },
                    { question: '我嘗試盡可能多記住讀過的材料內容。' },
                    { question: '我嘗試盡可能準確地記住不同材料中我認為重要的內容。' }
                ]
            }
        ],
        [
            {
                id: 'D',
                title: 'D　閱讀中的推測與瀏覽',
                hint: '請評定你在剛才的閱讀任務中，在多大程度上有以下做法。',
                options: [
                    '完全沒有',
                    '程度較低',
                    '中等程度',
                    '程度較高',
                    '程度非常高'
                ],
                questions: [
                    { question: '我會檢查自己對線上文本內容的猜測是否正確。' },
                    { question: '我會嘗試猜測文本接下來會出現甚麼內容。' },
                    { question: '我會猜測不認識的詞語或短語的意思。' },
                    { question: '為了快速了解文本的大意，我會閱讀每段的第一句。' },
                    { question: '開始閱讀一份線上文本時，我會先整體瀏覽，以了解它主要講甚麼。' },
                    { question: '我會上下捲動線上文本的頁面，找出其中不同要點之間的關係。' }
                ]
            }
        ],
        [
            {
                id: 'E',
                title: 'E　資訊的定位與選擇',
                hint: '請評定你在剛才的閱讀任務中，在多大程度上有以下做法。',
                options: [
                    '完全沒有',
                    '程度較低',
                    '中等程度',
                    '程度較高',
                    '程度非常高'
                ],
                questions: [
                    { question: '我會運用自己對主題的背景知識來定位需要的資訊。' },
                    { question: '我會運用自己對資訊類網站結構的了解（例如標題、分類欄目）來定位需要的資訊。' },
                    { question: '我會運用自己對紙本資訊類文章結構的了解（例如標題、段落安排）來定位需要的資訊。' },
                    { question: '我會比較不同網頁中的資訊，以篩選出最符合我閱讀目的的內容。' },
                    { question: '當某個連結對理解目前閱讀的線上文本很重要時，我會點擊該連結。' },
                    { question: '我會檢查讀到的新資訊是否符合我的閱讀目的。' },
                    { question: '我會檢查新網頁中的資訊，是否與我對已讀文本的理解一致。' }
                ]
            },
        ],
        [
            {
                id: 'F',
                title: 'F　閱讀中的選擇與評估',
                hint: '請評定你在剛才的閱讀任務中，在多大程度上有以下做法。',
                options: [
                    '完全沒有',
                    '程度較低',
                    '中等程度',
                    '程度較高',
                    '程度非常高'
                ],
                questions: [
                    { question: '我會有意識地選擇並點擊合適的連結，決定接下來閱讀哪些內容。' },
                    { question: '開始閱讀一個新網站時，我先快速瀏覽網站的主選單（例如不同欄目或頁面的連結）。' },
                    { question: '點擊連結前，我會提醒自己這次閱讀的目的。' },
                    { question: '在線上閱讀時，我會尋找呈現同一議題正反兩方面觀點的網站。' },
                    { question: '我會尋找關於同一主題的多份線上文本。' },
                    { question: '我會批判性地分析並評估線上文本中呈現的資訊。' }
                ]
            }
        ]
    ]
}
